import type { CSSProperties } from "react";

/** Layout props that must not override `.pb-toc[data-sticky="1"]` positioning. */
const STICKY_CONFLICT_KEYS = [
	"position",
	"top",
	"bottom",
	"left",
	"right",
	"zIndex",
	"height",
	"minHeight",
	"maxHeight",
	"overflow",
	"overflowY",
] as const;

type StickyConflictKey = (typeof STICKY_CONFLICT_KEYS)[number];

/**
 * Merge author styles onto the TOC `<nav>` without breaking sticky positioning.
 * Inline `position` (e.g. canvas `position: relative`) wins over CSS `position: sticky`.
 */
export function buildTocNavStyle(
	style: CSSProperties | undefined,
	sticky: boolean
): CSSProperties {
	const base = style ?? {};
	if (sticky) {
		const rest = { ...base };
		for (const key of STICKY_CONFLICT_KEYS) {
			delete rest[key as StickyConflictKey];
		}
		return rest;
	}
	return {
		...base,
		position: base.position ?? "relative",
	};
}
